import i18n from '../i18n'

export function attachmentFileExtension(attachment) {
  const name = attachment?.nomeOriginal || attachment?.nomeArquivo || ''
  const match = String(name).match(/\.([a-z0-9]+)$/i)
  return match ? match[1].toLowerCase() : 'arq'
}

/**
 * @param {string} ext
 * @param {(key: string, ...args: unknown[]) => string} [t] — use `useI18n().t` ou omitir para `i18n.global.t`
 */
export function attachmentFileTypeLabel(ext, t) {
  const translate = t || ((key) => i18n.global.t(key))
  const key = `attachments.types.${ext}`
  const known = [
    'pdf', 'xlsx', 'xls', 'csv', 'doc', 'docx', 'ppt', 'pptx',
    'zip', 'rar', '7z', 'txt', 'png', 'jpg', 'jpeg', 'gif', 'mp4', 'mp3', 'wav'
  ]
  if (known.includes(ext)) {
    return translate(key)
  }
  if (ext && ext !== 'arq') return ext.toUpperCase()
  return translate('attachments.file')
}

export function attachmentFileIconClass(attachment) {
  const ext = attachmentFileExtension(attachment)
  if (ext === 'pdf') return 'wa-doc-icon--pdf'
  if (['xlsx', 'xls', 'csv'].includes(ext)) return 'wa-doc-icon--sheet'
  if (['doc', 'docx'].includes(ext)) return 'wa-doc-icon--doc'
  if (['zip', 'rar', '7z'].includes(ext)) return 'wa-doc-icon--archive'
  return 'wa-doc-icon--default'
}

/**
 * @param {object} attachment
 * @param {(key: string, ...args: unknown[]) => string} [t]
 */
export function attachmentDisplayName(attachment, t) {
  const translate = t || ((key) => i18n.global.t(key))
  return attachment?.nomeOriginal || attachment?.nomeArquivo || translate('attachments.document')
}
